import { render, staticRenderFns } from "./glypay.vue?vue&type=template&id=f5c1ab7a&"
import script from "./glypay.vue?vue&type=script&lang=js&"
export * from "./glypay.vue?vue&type=script&lang=js&"
import style0 from "./glypay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports